const DOC_MESSAGE = "Attached Documents must be clear and visible.";
const MAX_FILE_SIZE = 3000000000;
const MAX_SIZE_MB = 3;
export default {
  DOC_MESSAGE: DOC_MESSAGE,
  MAX_FILE_SIZE: MAX_FILE_SIZE,
  MAX_SIZE_MB: MAX_SIZE_MB,
};
